export default __webpack_public_path__ + "static/media/310.297ee252.jpg";